export default {
    data() {
        return {
            open: {
                mapSetting: false,
                searchBox: false,
                locationListBox: false,
                directionsControl: false,
                localeBox: false,
                introductionBox: false,
                categoryBox: false,
                routeBox: false,
                galleryBox: false,
                directionsBox: false,
                listSearchBox: false,
                floorGuideBox: false,
            },
            isClickedLocationsFound: false,
            isOpenedListSearchBox: false,
            isOpenedFloorGuideBox: false,
            currentOpenSubSidebar: '',
        }
    },
    computed: {
        subSideBarState() {
            const sidebar = ['mapSetting', 'searchBox', 'locationListBox', 'localeBox', 'introductionBox', 'routeBox', 'galleryBox', 'directionsBox', 'listSearchBox', 'floorGuideBox'];
            for (const key in this.open) {
                if (sidebar.includes(key) && this.open[key] == true) {
                    return 'open';
                }
            }

            return 'close';
        },
        strOpen() {
            return JSON.stringify(this.open);
        }
    },
    methods: {
        hideLeftMapSections(except) {
            for (const key in this.open) {
                if (key == except) {
                    continue;
                }

                this.open[key] = false;
            }
        },
        openSubSidebar(payload) {
            if (this.isShowLocationDetail) {
                this.isShowLocationDetail = false;
            }
            if (this.isClickedLocationsFound) {
                this.isClickedLocationsFound = false;
            }
            if (this.isOpenedListSearchBox) {
                this.isOpenedListSearchBox = false;
            }
            if (this.isOpenedFloorGuideBox) {
                this.isOpenedFloorGuideBox = false;
            }
            this.currentOpenSubSidebar = '';
            if (['categoryBox','locationListBox'].includes(payload)) {
                this.currentOpenSubSidebar = payload;
            }
            if (payload === 'floorGuideBox') {
                this.currentCategoryId = 0;
            }
            for (const key in this.open) {
                this.open[key] = false
            }
            setTimeout(() => {
                this.open[payload] = true
            }, 550);
        }
    },
    watch: {
        strOpen(newVal, oldVal) {
            let newValue = JSON.parse(newVal);
            let oldValue = JSON.parse(oldVal);

            for (const key in newValue) {
                if (key == 'directionsControl') {
                    if (!this.useMapboxDirections) {
                        continue;
                    }
                }

                if (newValue[key] && !oldValue[key]) {
                    this.hideLeftMapSections(key);
                }
            }
        }
    }
};